import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage } from "../firebase";

function cleanFileName(name) {
  return String(name || "audio")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9._-]/g, "-")
    .replace(/-+/g, "-")
    .slice(0, 120);
}

export async function uploadServiceFiles(user, serviceId, files) {
  if (!user) throw new Error("Connexion obligatoire pour uploader.");
  const list = Array.from(files || []);

  const uploads = await Promise.all(
    list.map(async (file) => {
      const path = `service-orders/${user.uid}/${serviceId}/${Date.now()}-${cleanFileName(file.name)}`;
      const fileRef = ref(storage, path);
      await uploadBytes(fileRef, file, {
        contentType: file.type || "application/octet-stream",
      });
      const url = await getDownloadURL(fileRef);
      return {
        name: file.name,
        size: file.size,
        type: file.type,
        path,
        url,
      };
    })
  );

  return uploads;
}
